import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

//roleId:1家庭顾问，2老师，3超级管理员，4排课专员，5院校联系人，6学习顾问
const state = {
  isSp: 1,//0是sg后台，1是connect后台
  language: {},
  languageBtn: "中文", // 切换语言按钮文本
  languageObt:localStorage.getItem('languageObt')?localStorage.getItem('languageObt'):'en',//obt语言按钮zh-CN中文，en英文
  scrollbarWidth: 17, // 滚动条宽度
  areaCode: "", //zoneid
  areaCodeId: "", //id
  areaCodeString:'',//时区sting
  institutionUserId: "", //工作人员id
  roleId: "", //角色id
  sysUserId: "", //用户id
  roleCode: "",
  userInfo: localStorage.getItem('userInfo')?JSON.parse(localStorage.getItem('userInfo')):{}, //登录用户信息
  basicInfo: {}, //用户基本信息
  activeNav:2,//学生栏目侧边导航，学生2，家长3，家庭1
  activeNavStu:1,//学生详情侧边栏
  selStudentName:'',//学生列表搜索
  selStudentNameCn:'',//TE学生搜索
  selStudentNameEn:'',//TE学生搜索
  selTeacherName:'',//TE老师搜索
  selParentName:'',//家长列表搜索
  selFamilyName:'',//家庭列表搜索
  currentStu:{},//学生列表搜索
  currentParentIds:'',//家长列表搜索
  currentFamilyId:'',//家庭列表搜索
  isOBT: false,
  customerId268: "",
  zohoUserId268: "",
  stuMsg268: {},
  isTeacher:false,
  isPartTeacher: false,
  isAdmin: false,
  isTP: false,
  isStudyConsultant: false,
  isStudent268: false,
  listUserRole: [{}],
  department: '',
  needTop: true, // 是否需要顶部导航栏
  topIndex: "0",
  headUrl: "https://sg-media.oss-cn-shanghai.aliyuncs.com/be-service-portal/", // 图片链接
  defaultHead: "Alex.svg",
  // uploadUrl: 'http://dev.adinnet.cn/common/upload', // 艾艺开发文件上传链接
  // uploadUrl: 'https://connect.be.co:8200/common/upload', // 测试文件上传链接
  // uploadUrl: 'http://47.97.163.66:8100/common/upload', // 生产文件上传链接http
  uploadUrl: "https://connect.be.co:8200/common/upload", // 生产文件上传链接https
  uploadHeaders: {
    token: "1"
  }, // 文件上传链接
  isGlobalSpin: false,
  // 默认个人头像
  personalHead: [
    "Alex.svg",
    "Alice.svg",
    "Allan.svg",
    "Anna.svg",
    "Aron.svg",
    "Arthur.svg",
    "Austin.svg",
    "Bonnie.svg",
    "Carl.svg",
    "Ella.svg",
    "Emma.svg",
    "Eva.svg",
    "Frank.svg",
    "Frey.svg",
    "Grace.svg"
  ],
  familyHead: [
    "AliceFamily.png",
    "EmmaFamily.png",
    "FreyFamily.png",
    "HelenFamily.png",
    "IrisFamily.png",
    "JudithFamily.png",
    "JuliaFamily.png",
    "SarahFamily.png"
  ],
  // 后台维护的系统数值
  leixing: [], //课程类型
  leixingHelp: {}, //课程类型
  kemu: [], // 科目列表
  kecheng: [], // 课程列表(项目)
  bumen: [], // 部门
  gongzuo: [], // 1工作办公室
  guwen: [], // 2所属顾问组
  school: [], // 3所属校区
  zhicheng: [], // 4职称
  chanpin: [], // 5产品名称
  // kaoshi: [],// 6标化考试名称
  quhao: [], // 7区号
  fuwubao: [], // 8服务包
  kemuHelp: {}, // 科目列表
  kechengHelp: [], // 课程列表(项目)
  bumenHelp: {}, // 部门
  gongzuoHelp: {}, // 1工作办公室
  guwenHelp: {}, // 2所属顾问组
  schoolHelp: {}, // 3所属校区
  zhichengHelp: {}, // 4职称
  chanpinHelp: {}, // 5产品名称
  // kaoshiHelp: {},// 6标化考试名称
  quhaoHelp: [], // 7区号
  fuwubaoHelp: [], // 8服务包
  jueseHelp: {
    1: "Consultants",
    2: "Teachers"
  }, // 角色(暂时写死)

  // 前端写死的系统数值
  userRole: [], // 角色
  userRoleHelp: {}, // 角色
  userRolePower: {}, // 角色权限
  shenfen: [], // 身份
  shenfenHelp: {}, // 身份
  englishLevel: [], // 英语水平
  englishLevelHelp: {}, // 英语水平
  religion: [], // 宗教
  religionHelp: {}, // 宗教
  visaCountry: [], // 签证国家
  visaCountryHelp: {}, // 签证国家
  productLine: [], // 产品线
  productLineHelp: {}, // 产品线
  Nationality: [], // 国籍
  NationalityHelp: {}, // 国籍
  quanjian: [], // 全职兼职
  quanjianHelp: {}, // 全职兼职
  xingshi: [], // 上课形式
  xingshiHelp: {}, // 上课形式
  jiuzhi: [], // 就职状态
  jiuzhiHelp: {}, // 就职状态
  xiangmu: [], // 项目类型
  xiangmuHelp: {}, // 项目类型
  objActList: [], // 项目进度
  objActListHelp: {}, // 项目进度
  objActStatusList: [],
  objActStatusListHelp: {},
  sex: [], // 性别
  sexHelp: {}, // 性别
  englishLevel: [], // 英语水平
  englishLevelHelp: {}, // 英语水平
  examName: [], // 标化考试名称
  examNameHelp: {}, // 标化考试名称
  examScore: [], // 标化考试能力
  examScoreHelp: {}, // 标化考试能力
  relationship: [], // 家庭关系
  relationshipHelp: {}, // 家庭关系
  perType: [], // 定制类型
  perTypeHelp: {}, // 定制类型
  jobTitle: [], // 职称
  jobTitleHelp: {}, // 职称
  timeZone: [], // 时区
  timeZoneHelp: {}, // 时区
  timeZonePart: [],
  timeZonePartHelp: {}, //部分时区
  offerStatus: [], //院校是否接受offer
  offerStatusEditHelp: {}, //院校是否接受offer
  offerType: [], //院校offer类型
  offerTypeHelp: {}, //院校offer类型
  appResult: [], //院校录取结果
  appResultHelp: {}, //院校录取结果
  priority: [], //院校筛选
  priorityHelp: {}, //院校筛选
  schoolType: [], //学校类型
  schoolTypeHelp: {}, //学校类型
  entryPoint: [], //申请学年
  entryPointHelp: {}, //申请学年
  StudentUKYearGroup: [], //学生学年
  StudentUKYearGroupHelp: {}, //学生学年
  schoolCategory: [], //院校类别
  schoolCategoryHelp: {}, //院校类别
  stuQian: [30, 10], // 学生签到时间区间
  teaQian: [120, 0], // 教师签到时间区间
  visualTime: [], //可视时段
  visualTimeHelp: {}, //可视时段
  groupProductLine: [], //学辅体验产品
  groupProductLineHelp: {}, //学辅体验产品
  invisibleTo: [], //可见角色
  invisibleToHelp: {}, //可见角色
  FeedbackType: [], //反馈类型
  FeedbackTypeHelp: {}, //反馈类型
  feedbackStatus:[],//反馈状态
  feedbackStatusHelp:{},//反馈状态
  FeedbackCaseType: [], //反馈项目类型区分SA和TE
  FeedbackCaseTypeHelp: {}, //反馈项目类型区分SA和TE
  schoolTag: [], //院校标签
  schoolTagHelp: {}, //院校标签
  yesOrNo: [], //下拉是否
  yesOrNoHelp: {}, //下拉是否
  sixthFormCurriculum: [], //英国六年级课程
  sixthFormCurriculumHelp: {}, //英国六年级课程
  forYear: [], //适用学年
  forYearHelp: {}, //适用学年
  nextYearDeadline: [], //下一年申请注册截止日
  nextYearDeadlineHelp: {}, //下一年申请注册截止日
  curriculum: [], //课程体系
  curriculumHelp: {}, //课程体系
  currentCurriculum: [], //学生课程
  currentCurriculumHelp: {}, //学生课程
  schoolCountry: [], //学校内国家
  schoolCountryHelp: {}, //学校内国家
  entryPointUK: [], //学年UK
  entryPointUKHelp: {}, //学年UK
  entryPointUS: [], //学年US
  entryPointUSHelp: {}, //学年US
  teachingExperience: [], //教学经验
  teachingExperienceHelp: {}, //教学经验
  degreeLevel: [], //学位
  degreeLevelHelp: {}, //学位
  fileType: [], //文件类型
  fileTypeHelp: {}, //文件类型
  commentType: [], //文件类型
  commentTypeHelp: {}, //文件类型

  productFilter: [], //产品筛选新增无
  productFilterHelp: {}, //产品筛选新增无
  dropYearPolicy: [], //是否有明确降级
  dropYearPolicyHelp: {}, //是否有明确降级
  alisBETopSchool: [], //院校简介alisBETopSchool
  alisBETopSchoolHelp: {}, //院校简介alisBETopSchool
  settings: [],
  settingsHelp: {},
  extracurricularActivities: [],
  extracurricularActivitiesHelp: {},
  competitiveness: [],
  competitivenessHelp: {},
  yearOfGreduation: [],
  yearOfGreduationHelp: {},
  roleOfCommentator: [],
  roleOfCommentatorHelp: {},
  beStaff: [],
  beStaffHelp: {},
  handbookYear: [],
  handbookYearHelp: {},
  fullBoardingYear: [], //招生提供全日制寄宿学年
  fullBoardingYearHelp: {}, //招生提供全日制寄宿学年
  examType: [], //笔试面试
  examTypeHelp: {}, //笔试面试
  stuStatus: [], //学生状态
  stuStatusHelp: {}, //学生状态
  registStatusEdit: [], //
  registStatusEditHelp: {}, //目标院校-注册状态
  registStatusAssignee: [], //
  registStatusAssigneeHelp: {}, //目标院校-注册状态
  registStatusAll: [], //
  registStatusAllHelp: {}, //目标院校-注册状态
  registStatusTask: [], //
  registStatusTaskHelp: {}, //目标院校-注册状态

  preScreeningStatusEdit: [], //
  preScreeningStatusEditHelp: {}, //目标院校-独家代理
  preScreeningStatusAssignee: [], //
  preScreeningStatusAssigneeHelp: {}, //目标院校-独家代理
  preScreeningStatusAll: [], //
  preScreeningStatusAllHelp: {}, //目标院校-独家代理
  preScreeningStatusTask: [], //
  preScreeningStatusTaskHelp: {}, //目标院校-独家代理

  ISEBStatusAll: [], //
  ISEBStatusAllHelp: {}, //目标院校-其他考试
  ISEBStatusTask: [], //
  ISEBStatusTaskHelp: {}, //目标院校-其他考试
  ISEBStatusEdit: [], //
  ISEBStatusEditHelp: {}, //目标院校-其他考试
  ISEBStatusAssignee: [], //
  ISEBStatusAssigneeHelp: {}, //目标院校-其他考试

  referenceStatusAssignee: [], //
  referenceStatusAssigneeHelp: {}, //目标院校-推荐信
  referenceStatusEdit: [], //
  referenceStatusEditHelp: {}, //目标院校-推荐信
  referenceStatusAll: [], //
  referenceStatusAllHelp: {}, //目标院校-推荐信
  referenceStatusTask: [], //
  referenceStatusTaskHelp: {}, //目标院校-推荐信

  assessmentStatusEdit: [], //
  assessmentStatusEditHelp: {}, //目标院校-测试 Assessment day
  assessmentStatusAssignee: [], //
  assessmentStatusAssigneeHelp: {}, //目标院校-测试 Assessment day
  assessmentStatusAll: [], //
  assessmentStatusAllHelp: {}, //目标院校-测试 Assessment day
  assessmentStatusTask: [], //
  assessmentStatusTaskHelp: {}, //目标院校-测试 Assessment day

  entranceStatusEdit: [], //
  entranceStatusEditHelp: {}, //目标院校-入学考试
  entranceStatusAssignee: [], //
  entranceStatusAssigneeHelp: {}, //目标院校-入学考试
  entranceStatusAll: [], //
  entranceStatusAllHelp: {}, //目标院校-入学考试
  entranceStatusTask: [], //
  entranceStatusTaskHelp: {}, //目标院校-入学考试

  visitStatusEdit: [], //
  visitStatusEditHelp: {}, //目标院校-访校
  visitStatusAssignee: [], //
  visitStatusAssigneeHelp: {}, //目标院校-访校
  visitStatusAll: [], //
  visitStatusAllHelp: {}, //目标院校-访校
  visitStatusTask: [], //
  visitStatusTaskHelp: {}, //目标院校-访校

  interviewStatusEdit: [],
  interviewStatusEditHelp: {}, //目标院校-面试
  interviewStatusAssignee: [],
  interviewStatusAssigneeHelp: {}, //目标院校-面试
  interviewStatusAll: [],
  interviewStatusAllHelp: {}, //目标院校-面试
  interviewStatusTask: [],
  interviewStatusTaskHelp: {}, //目标院校-面试

  schoolDecisionStatusEdit: [],
  schoolDecisionStatusEditHelp: {}, //目标院校-院校公布结果
  schoolDecisionStatusAssignee: [],
  schoolDecisionStatusAssigneeHelp: {}, //目标院校-院校公布结果
  schoolDecisionStatusAll: [],
  schoolDecisionStatusAllHelp: {}, //目标院校-院校公布结果
  schoolDecisionStatusTask: [],
  schoolDecisionStatusTaskHelp: {}, //目标院校-院校公布结果

  familyDecisionStatusEdit: [], //目标院校-学生决定
  familyDecisionStatusEditHelp: {}, //目标院校-学生决定
  familyDecisionStatusAssignee: [], //目标院校-学生决定
  familyDecisionStatusAssigneeHelp: {}, //目标院校-学生决定
  familyDecisionStatusAll: [], //目标院校-学生决定
  familyDecisionStatusAllHelp: {}, //目标院校-学生决定
  familyDecisionStatusTask: [], //目标院校-学生决定
  familyDecisionStatusTaskHelp: {}, //目标院校-学生决定

  finalTestStatusEdit: [], //目标院校-最终考试
  finalTestStatusEditHelp: {}, //目标院校-最终考试
  finalTestStatusAssignee: [], //目标院校-最终考试
  finalTestStatusAssigneeHelp: {}, //目标院校-最终考试
  finalTestStatusAll: [], //目标院校-最终考试
  finalTestStatusAllHelp: {}, //目标院校-最终考试
  finalTestStatusTask: [], //目标院校-最终考试
  finalTestStatusTaskHelp: {}, //目标院校-最终考试
  testpaperEng: [],
  testpaperEngHelp: {},
  testpaperMath: [],
  testpaperMathHelp: {},
  testpaperVr: [],
  testpaperVrHelp: {},
  taskTypeList: [],
  taskTypeListHelp: {},
  rejectReasonList: [],
  rejectReasonListHelp: {},
  testLocation: [],
  testLocationHelp: {},
  callList: [],
  callListHelp: {},
  stuTaskTypeList: [],
  stuTaskTypeListHelp: {},
  countrycode: [], //国家号
  countrycodeHelp: {},
  appellationType: [],
  appellationTypeHelp: {},
  externOrBoarder: [],
  externOrBoarderHelp: {},
  parentMartialStatus: [],
  parentMartialStatusHelp: {},
  perferredLanguage: [],
  perferredLanguageHelp: {},
  schoolTypeSpecial: [],
  schoolTypeSpecialHelp: {},
  subjectTuitionType: [],
  subjectTuitionTypeHelp: {},
  isRequired: [],
  isRequiredHelp: {},
  requestFormStatus: [],
  requestFormStatusHelp: {},
  studyPlanWeek: [],
  studyPlanWeekHelp: {}
};

// userInfo: {},
//     basicInfo: {},
//     isOBT:false,
//     customerId268:'',
//     zohoUserId268:'',
//     stuMsg268:{},
//     listUserRole: [{}],
//     department:localStorage.getItem('department'),

const mutations = {
  SET_SPIN(state, isGlobalSpin) {
    state.isGlobalSpin = isGlobalSpin;
  },
  SET_BASIC_INFO: (state, basicInfo) => {
    state.basicInfo = basicInfo;
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_DEPARTMENT: (state, department) => {
    state.department = department;
  },
  SET_isOBT: (state, isOBT) => {
    state.isOBT = isOBT;
  },
  SET_LANOBT: (state, languageObt) => {
    state.languageObt = languageObt;
  },
  SET_ISSP: (state, isSp) => {
    state.isSp = isSp;
  },
  SET_NEEDTOP: (state, needTop) => {
    state.needTop = needTop;
  },
  SET_CUSTOMER_ID268: (state, customerId268) => {
    state.customerId268 = customerId268;
  },
  SET_ZOHO_ID268: (state, zohoUserId268) => {
    state.zohoUserId268 = zohoUserId268;
  },
  SET_STU_MSG268: (state, stuMsg268) => {
    state.stuMsg268 = stuMsg268;
  },
  SET_AREACODE: (state, areaCode) =>{
    state.areaCode = areaCode;
  },
  SET_AREACODE_STRING: (state, areaCodeString) =>{
    state.areaCodeString = areaCodeString;
  }
};
const getters = {
  institutionUserId: state => state.basicInfo.id,
  roleId: state => state.userInfo.roleId,
  sysUserId: state => state.userInfo.userId,
  roleCode: state => state.userInfo.roleCode,
  areaCode: state => state.basicInfo.areaCode&&state.basicInfo.areaCode.indexOf('&')?state.basicInfo.areaCode.split('&')[0]:'8',//时区zoneid
  areaCodeId: state => state.basicInfo.areaCode&&state.basicInfo.areaCode.indexOf('&')?state.basicInfo.areaCode.split('&')[1]:'8',//时区id
  areaCodeString: state => state.basicInfo.areaCode&&state.basicInfo.areaCode.indexOf('&')&&state.basicInfo.areaCode.split('&').length>2?state.basicInfo.areaCode.split('&')[2]:'Asia/Shanghai',//时区string
  listUserRole: state => state.basicInfo.listUserRole,
  isTeacher: state => state.userInfo.roleId == 2 || state.userInfo.roleId == 92,
  isPartTeacher: state => state.userInfo.roleId == 92,
  isAdmin: state => state.userInfo.roleId == 3,
  isTP: state => state.userInfo.roleId == 91,
  isStudyConsultant: state => state.userInfo.roleId == 6 || state.userInfo.roleId == 1,
  isLeader: state => state.department.isLeader
};
const store = new Vuex.Store({
  state,
  mutations,
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js